import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { UPDATE_CLIENT_SCORING_RESULT_STATUS } from '../types';
import {
  updateClientScoringResultStatusPending,
  updateClientScoringResultStatusFulfilled,
  updateClientScoringResultStatusRejected,
} from '../actions';
import {
  sendApiRequest,
  notifyError,
} from '../../../actions';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'post',
  url: 'scoreCard/changeClientScoringStatus',
  onSuccess: [
    updateClientScoringResultStatusFulfilled,
  //  () => notifySuccess(CLIENT_SCORING_RESULT_MESSAGES.SUCCESS),
    //  () => windowReload(),
  ],
  onError: [
    updateClientScoringResultStatusRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const updateClientScoringResultStatusEpic$ = action$ => action$.pipe(
  ofType(UPDATE_CLIENT_SCORING_RESULT_STATUS.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(updateClientScoringResultStatusPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default updateClientScoringResultStatusEpic$;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/updateClientScoringResultStatusEpic.js